export { Logotype } from './Component'
